// extracted by mini-css-extract-plugin
module.exports = {"info_section":"GeneralPagesStyle_info_section__29BU1"};